"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var fetchAppNexusNativeAds_1 = require("../services/fetchAppNexusNativeAds");
var fetchBingNativeAds_1 = require("../services/fetchBingNativeAds");
var fetchPrebidNativeAds_1 = require("../services/fetchPrebidNativeAds");
var fetchTaboolaNativeAds_1 = require("../services/fetchTaboolaNativeAds");
var generateDefaultOutlookAds_1 = require("../services/generateDefaultOutlookAds");
var owa_mail_ads_shared_1 = require("owa-mail-ads-shared");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var owa_mail_messagead_store_1 = require("owa-mail-messagead-store");
var querystring_1 = require("querystring");
/* tslint:disable:forbid-import */
var satcheljs_1 = require("satcheljs");
/* tslint:enable:forbid-import */
exports.default = satcheljs_1.orchestratorAction('loadMessageAdList', function loadMessageAdList(triggerEvent) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var params, returnedMessageAds, adMarket, plannedMessageAdType, isOneClick, isFireFox, originalPlannedMessageAdType;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = typeof location !== 'undefined' && location.search ? querystring_1.parse(location.search.substr(1)) : {};
                    adMarket = params.ormarket || owa_mail_ads_shared_1.getAdMarketPublishGroupCode();
                    if (!owa_mail_feature_flags_1.isMailFeatureEnabled('fwk-nativeAds-bingTwoClick')) return [3 /*break*/, 2];
                    plannedMessageAdType = "BingTwoClick" /* BingTwoClick */;
                    return [4 /*yield*/, fetchBingNativeAds_1.default("BingTwoClick" /* BingTwoClick */, adMarket, triggerEvent)];
                case 1:
                    returnedMessageAds = _a.sent();
                    return [3 /*break*/, 24];
                case 2:
                    if (!owa_mail_feature_flags_1.isMailFeatureEnabled('fwk-nativeAds-bingOneClick')) return [3 /*break*/, 4];
                    plannedMessageAdType = "BingOneClick" /* BingOneClick */;
                    isOneClick = true;
                    return [4 /*yield*/, fetchBingNativeAds_1.default("BingOneClick" /* BingOneClick */, adMarket, triggerEvent)];
                case 3:
                    returnedMessageAds = _a.sent();
                    return [3 /*break*/, 24];
                case 4:
                    if (!owa_mail_feature_flags_1.isMailFeatureEnabled('fwk-nativeAds-bingOneClickOtherInboxOnly')) return [3 /*break*/, 6];
                    plannedMessageAdType = "BingOneClickOIO" /* BingOneClickOIO */;
                    isOneClick = true;
                    return [4 /*yield*/, fetchBingNativeAds_1.default("BingOneClickOIO" /* BingOneClickOIO */, adMarket, triggerEvent)];
                case 5:
                    returnedMessageAds = _a.sent();
                    return [3 /*break*/, 24];
                case 6:
                    if (!owa_mail_feature_flags_1.isMailFeatureEnabled('fwk-nativeAds-appNexusTwoClick')) return [3 /*break*/, 10];
                    plannedMessageAdType = "AppNexusTwoClick" /* AppNexusTwoClick */;
                    return [4 /*yield*/, fetchAppNexusNativeAds_1.default("AppNexusTwoClick" /* AppNexusTwoClick */, adMarket, triggerEvent)];
                case 7:
                    returnedMessageAds = _a.sent();
                    if (!(returnedMessageAds == null)) return [3 /*break*/, 9];
                    plannedMessageAdType = "TaboolaTwoClick" /* TaboolaTwoClick */;
                    return [4 /*yield*/, fetchTaboolaNativeAds_1.default("TaboolaTwoClick" /* TaboolaTwoClick */, "AppNexusTwoClick" /* AppNexusTwoClick */, adMarket, triggerEvent)];
                case 8:
                    returnedMessageAds = _a.sent();
                    _a.label = 9;
                case 9: return [3 /*break*/, 24];
                case 10:
                    if (!owa_mail_feature_flags_1.isMailFeatureEnabled('fwk-nativeAds-appNexusOneClick')) return [3 /*break*/, 14];
                    plannedMessageAdType = "AppNexusOneClick" /* AppNexusOneClick */;
                    isOneClick = true;
                    return [4 /*yield*/, fetchAppNexusNativeAds_1.default("AppNexusOneClick" /* AppNexusOneClick */, adMarket, triggerEvent)];
                case 11:
                    returnedMessageAds = _a.sent();
                    if (!(returnedMessageAds == null)) return [3 /*break*/, 13];
                    plannedMessageAdType = "TaboolaOneClick" /* TaboolaOneClick */;
                    return [4 /*yield*/, fetchTaboolaNativeAds_1.default("TaboolaOneClick" /* TaboolaOneClick */, "AppNexusOneClick" /* AppNexusOneClick */, adMarket, triggerEvent)];
                case 12:
                    returnedMessageAds = _a.sent();
                    _a.label = 13;
                case 13: return [3 /*break*/, 24];
                case 14:
                    if (!owa_mail_feature_flags_1.isMailFeatureEnabled('fwk-nativeAds-appNexusOneClickOtherInboxOnly')) return [3 /*break*/, 18];
                    plannedMessageAdType = "AppNexusOneClickOIO" /* AppNexusOneClickOIO */;
                    isOneClick = true;
                    return [4 /*yield*/, fetchAppNexusNativeAds_1.default("AppNexusOneClickOIO" /* AppNexusOneClickOIO */, adMarket, triggerEvent)];
                case 15:
                    returnedMessageAds = _a.sent();
                    if (!(returnedMessageAds == null)) return [3 /*break*/, 17];
                    plannedMessageAdType = "TaboolaOneClickOIO" /* TaboolaOneClickOIO */;
                    return [4 /*yield*/, fetchTaboolaNativeAds_1.default("TaboolaOneClickOIO" /* TaboolaOneClickOIO */, "AppNexusOneClickOIO" /* AppNexusOneClickOIO */, adMarket, triggerEvent)];
                case 16:
                    returnedMessageAds = _a.sent();
                    _a.label = 17;
                case 17: return [3 /*break*/, 24];
                case 18:
                    if (!owa_mail_feature_flags_1.isMailFeatureEnabled('fwk-nativeAds-prebidOneClickOtherInboxOnly')) return [3 /*break*/, 24];
                    isOneClick = true;
                    isFireFox = typeof navigator != 'undefined' &&
                        navigator.userAgent &&
                        navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
                    if (!(triggerEvent != 'init' ||
                        (owa_mail_feature_flags_1.isMailFeatureEnabled('fwk-nativeAds-prebidTurnOffFanOnFireFox') && isFireFox))) return [3 /*break*/, 20];
                    plannedMessageAdType = "AppNexusOneClickOIO" /* AppNexusOneClickOIO */;
                    return [4 /*yield*/, fetchAppNexusNativeAds_1.default("AppNexusOneClickOIO" /* AppNexusOneClickOIO */, adMarket, triggerEvent)];
                case 19:
                    returnedMessageAds = _a.sent();
                    return [3 /*break*/, 22];
                case 20:
                    plannedMessageAdType = "PrebidOneClickOIO" /* PrebidOneClickOIO */;
                    return [4 /*yield*/, fetchPrebidNativeAds_1.default("PrebidOneClickOIO" /* PrebidOneClickOIO */, adMarket, triggerEvent)];
                case 21:
                    returnedMessageAds = _a.sent();
                    _a.label = 22;
                case 22:
                    if (!(returnedMessageAds == null)) return [3 /*break*/, 24];
                    originalPlannedMessageAdType = plannedMessageAdType;
                    plannedMessageAdType = "TaboolaOneClickOIO" /* TaboolaOneClickOIO */;
                    return [4 /*yield*/, fetchTaboolaNativeAds_1.default("TaboolaOneClickOIO" /* TaboolaOneClickOIO */, originalPlannedMessageAdType, adMarket, triggerEvent)];
                case 23:
                    returnedMessageAds = _a.sent();
                    _a.label = 24;
                case 24:
                    if (returnedMessageAds == null) {
                        returnedMessageAds = generateDefaultOutlookAds_1.default(plannedMessageAdType, adMarket, isOneClick, triggerEvent);
                    }
                    owa_mail_messagead_store_1.populateAds(returnedMessageAds);
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=loadMessageAdList.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-messagead-orchestration/lib/orchestrators/loadMessageAdList.js
// module id = 6009
// module chunks = 67